import React from 'react';
import {Redirect, Route} from 'react-router-dom';
import {connect} from "react-redux";

const ProtectedRoute = ({component: Component, layout: Layout, ...rest}) => {
    return (
        <Route {...rest} render={
            props => {
                if (rest.isAuthenticated) {
                    return <Layout><Component {...rest} {...props} /> </Layout>
                } else {
                    // todo: add back url
                    return <Redirect from={window.location.href} to={
                        {
                            pathname: '/',
                            state: {
                                from: props.location
                            }
                        }
                    }/>
                }
            }
        }/>
    )
}
const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.isAuthenticated
    };
};


export default connect(mapStateToProps)(ProtectedRoute);